/* Place the product's own narrative before the purchase controls and its table below.
   Without JS the complete original description remains in the lower section. */
(() => {
  function arrangeInformation() {
    const description = document.getElementById('SyunProductDescription');
    const target = document.querySelector('[data-syun-product-summary]');
    const specs = document.getElementById('SyunProductSpecs');
    if (!description || !target || !specs || description.dataset.syunArranged) return;
    description.dataset.syunArranged = 'true';
    const tables = Array.from(description.querySelectorAll('table'));
    if (tables.length) {
      tables.forEach((table) => {
        table.querySelectorAll('tr').forEach((row) => {
          if (row.cells.length !== 2 || row.cells[0].tagName !== 'TD') return;
          const label = row.cells[0];
          const heading = document.createElement('th');
          Array.from(label.attributes).forEach(({ name, value }) => heading.setAttribute(name, value));
          heading.scope = 'row';
          while (label.firstChild) heading.append(label.firstChild);
          label.replaceWith(heading);
        });
      });
      const specsHeading = document.createElement('h2');
      specsHeading.textContent = '原材料・仕様';
      specs.append(specsHeading, ...tables);
      specs.hidden = false;
      description.parentElement.querySelector('[data-syun-spec-link]')?.setAttribute('href', '#SyunProductSpecs');
    }
    description.querySelectorAll('p, div').forEach((node) => {
      if (!node.textContent.trim() && !node.querySelector('img, video, iframe')) node.remove();
    });
    const hasNarrative = description.textContent.trim() || description.querySelector('img, video, iframe');
    if (hasNarrative) {
      const heading = document.createElement('h2');
      heading.textContent = '商品について';
      const body = document.createElement('div');
      body.className = 'rte syun-product-summary__body';
      while (description.firstChild) body.append(description.firstChild);
      target.append(heading, body);
    }
    description.hidden = true;
    if (!tables.length) {
      description.parentElement.querySelector('[data-syun-spec-link]')?.remove();
      description.parentElement.classList.add('syun-product-story__details--empty');
      description.closest('.syun-product-story__grid')?.classList.add('syun-product-story__grid--no-details');
    }
  }
  function connectMobileBuy() {
    const bar = document.querySelector('[data-syun-mobile-buy]');
    const proxy = document.querySelector('[data-syun-mobile-buy-button]');
    const original = document.querySelector('.syun-page-product .product-form__submit');
    if (!bar || !proxy || !original || proxy.dataset.syunConnected) return;
    proxy.dataset.syunConnected = 'true';
    const originalParent = original.parentNode;
    const originalNextSibling = original.nextSibling;
    const form = original.closest('form');
    const formId = form?.getAttribute('id');
    const mobile = window.matchMedia('(max-width: 749px)');

    // Keep the real submit button under the user's pointer. A synthetic click on
    // the proxy bypasses validation added by purchase-limit apps.
    if (formId) original.setAttribute('form', formId);
    const placeButton = () => {
      if (mobile.matches) {
        proxy.hidden = true;
        bar.append(original);
        return;
      }
      originalParent.insertBefore(original, originalNextSibling);
      proxy.hidden = false;
    };
    placeButton();
    mobile.addEventListener('change', placeButton);
  }
  function initialize() { arrangeInformation(); connectMobileBuy(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
